exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trip-alert {\n  margin: 0;\n}\n.trip-alert p {\n  margin-bottom: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: center;\n}\n.trip-alert strong {\n  display: block;\n  font-size: 16px;\n}\n.trip-alert--danger {\n  color: #E80085FF;\n}", ""]);

// exports
